import { BusinessSubscriptionNameToDisplayViewModel } from './business-subscription-name-to-display';
import { BusinessSubscriptionDescriptionToDisplayViewModel } from './business-subscription-description-to-display';
import { VisibilityModes } from '@/services';

export class BusinessSubscriptionPricingViewModel {
    public pricingId: number;
    public isBusinessSubscribedTo: boolean;
    public priceBase: number;
    public priceFinal: number;
    public discount: number;
    public level: number;
    public namesToDisplay: BusinessSubscriptionNameToDisplayViewModel[];
    public descriptionsToDisplay: BusinessSubscriptionDescriptionToDisplayViewModel[];
    public visibility: VisibilityModes;

    constructor(
        pricingId: number,
        isBusinessSubscribedTo: boolean,
        priceBase: number,
        priceFinal: number,
        discount: number,
        level: number,
        namesToDisplay: BusinessSubscriptionNameToDisplayViewModel[],
        descriptionsToDisplay: BusinessSubscriptionDescriptionToDisplayViewModel[],
        visibility: VisibilityModes
    ) {
        this.pricingId = pricingId;
        this.isBusinessSubscribedTo = isBusinessSubscribedTo;
        this.discount = discount;
        this.priceBase = priceBase;
        this.priceFinal = priceFinal;
        this.level = level;
        this.namesToDisplay = namesToDisplay;
        this.descriptionsToDisplay = descriptionsToDisplay;
        this.visibility = visibility;
    }

    public backgroundImage(index: number): string {
        if (index > 4) {
            return '';
        }
        return require(`@/assets/illustration/PricePlans/Plan${index}-1.jpg`);
    }

    public getName(locale: string): string {
        const nameToDisplay = this.namesToDisplay.find(e => e.culture === locale);
        if (nameToDisplay) {
            return nameToDisplay.name;
        }
        return '';
    }

    public getDescription(locale: string): string {
        const descriptionToDisplay = this.descriptionsToDisplay.find(e => e.culture === locale);
        if (descriptionToDisplay) {
            return descriptionToDisplay.description;
        }
        return '';
    }
}
